import React from 'react';
import PropTypes from 'prop-types';

function PhoneIcon({ className = 'h-4 w-4' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
      aria-hidden
    >
      <rect width='14' height='20' x='5' y='2' rx='2' ry='2' />
      <path d='M12 18h.01' />
    </svg>
  );
}

PhoneIcon.propTypes = {
  className: PropTypes.string,
};

export default PhoneIcon;
